import { FunctionComponent, PropsWithChildren, ReactNode } from "react";

import * as Styled from "./styles";
import { BodyLargeBold } from "../font";

interface ListContainerProps extends PropsWithChildren {
  name: string;
  className?: string;
  padding?: string;
  backgroundColor?: string;
}

export const ListContainer: FunctionComponent<ListContainerProps> = ({
  name,
  className = "",
  children,
  padding = undefined,
  backgroundColor = undefined,
}: ListContainerProps) => {
  return (
    <Styled.ListContainerDiv
      data-name={name}
      className={className}
      $padding={padding}
      $backgroundColor={backgroundColor}
    >
      {children}
    </Styled.ListContainerDiv>
  );
};

interface ListItemProps {
  name?: string;
  className?: string;
  icon?: React.ReactNode;
  iconSpacing?: string;
  heading: string | ReactNode;
  body?: string;
  paddingLeft?: string;
  paddingRight?: string;
  maxWidth?: string;
  size?: "medium" | "large";
}

export const ListItem: FunctionComponent<ListItemProps> = ({
  name = undefined,
  heading,
  body = undefined,
  icon = undefined,
  className = "",
  iconSpacing = undefined,
  paddingLeft = undefined,
  paddingRight = undefined,
  maxWidth = "100%",
  size = "medium",
}: ListItemProps) => {
  return (
    <Styled.ListItem
      className={className}
      data-name={name || heading}
      $paddingLeft={paddingLeft}
      $paddingRight={paddingRight}
      $maxWidth={maxWidth}
    >
      {icon && <Styled.ListItemIcon $iconSpacing={iconSpacing}>{icon}</Styled.ListItemIcon>}
      <Styled.ListItemContent $withBody={body !== undefined} $size={size}>
        {size === "large" ? <BodyLargeBold>{heading}</BodyLargeBold> : <p className="heading">{heading}</p>}
        {body && <p className="body">{body}</p>}
      </Styled.ListItemContent>
    </Styled.ListItem>
  );
};
